export const canAddProductToCart = (product) => {
    if (product.customFields && product.customFields.length > 0) {
        return false;
    }
    if (Object.keys(product.productOptions || {}).length > 0) {
        return false;
    }
    return true;
};
//# sourceMappingURL=stores.js.map